"use client";

import StaffBioModal from "../../../../_components/StaffBioModal";
import StaffMember from "../../../../types/StaffMember";
import StaticCampusStaffCard from "./StaticCampusStaffCard";

/**
 * Interactive campus staff card featuring an individual staff member.
 * On click opens a modal with staff details (see CampusStaffDetails)
 * @param staffData A staff member type object
 * @returns An interactive campus staff card
 */
const CampusStaffCard: React.FC<StaffMember> = (staffData) => {
	return (
		<StaffBioModal staffMember={staffData}>
			<StaticCampusStaffCard {...staffData} />
		</StaffBioModal>
	);
};

export default CampusStaffCard;
